import ClearIcon from "@mui/icons-material/Clear";
import { MenuItem, Select } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { useContext, useEffect, useMemo, useState } from "react";
import CloseIcon from "../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../contexts/RequestController";
import TabelaRedux from "../../../contexts/Tabela";
import MotionContainer from "../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../core/components/Separator.tsx";
import Layout from "../../../core/layout/Layout.tsx";
import {
	cadastraTipoCheckagem,
	deleteTipoCheckagemPorId,
	editaTipoCheckagemPorId,
	getTipoCheckagem,
	getTipoCheckagemPorId,
} from "../../../services/ModuloChecklist/TipoCheckagem";
import "./TipoCheckagem.css";

function TipoCheckagem(props) {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [valuesData, setValuesData] = useState([]);

	const [validator, setValidator] = useState([]);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [tipoNotificacao, setTipoNotificacao] = useState([
		"Por Data",
		"Por KM",
	]);

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarTipoCheckagem = async () => {
		setLoading(true);
		await getTipoCheckagem(profile?.token)
			.then((result) => {
				setDadosTabela(result.data);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 1000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const cadastrar = async () => {
		if (
			values.nome !== "" &&
			validator.nome === "true" &&
			valuesData.dia !== "" &&
			validator.dia === "true" &&
			valuesData.mes !== "" &&
			validator.mes === "true" &&
			valuesData.ano !== "" &&
			validator.ano === "true"
		) {
			setLoading(true);
			await cadastraTipoCheckagem(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarTipoCheckagem();
						setDadosRequestControllerRedux("Fechar Modal TipoCheckagem");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		setLoading(true);
		await editaTipoCheckagemPorId(values, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoCheckagem();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const formatarData = async (data) => {
		const dia = data.split("d")[0].split(" ")[2];
		const mes = data.split("m")[0].split(" ")[1];
		const ano = data.split("a")[0];
		setValuesData((current) => ({ ...current, ano: ano }));
		setValuesData((current) => ({ ...current, mes: mes }));
		setValuesData((current) => ({ ...current, dia: dia }));
	};

	const buscarTipoCheckagemPorId = async () => {
		setLoading(true);
		await getTipoCheckagemPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await formatarData(result.data.notificarACadaData);
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const buscarTipoCheckagemPorIdModal = async (id) => {
		setLoading(true);
		await getTipoCheckagemPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					await formatarData(result.data.notificarACadaData);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				}
			});
	};

	const title = useMemo(() => {
		if (editando) return "Detalhes de Checkagem";
		if (telaCadastro) return "Cadastro de Checkagem";
		return "Tipo de Checkagem";
	}, [editando, telaCadastro]);

	const deletarTipoCheckagemPorId = async () => {
		setLoading(true);
		await deleteTipoCheckagemPorId(
			tabelaRedux.colunaSelecionada,
			profile?.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarTipoCheckagem();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		setValues((current) => ({
			...current,
			usuario: profile?.usuario.usuario,
		}));
		setValues((current) => ({ ...current, notificarACadaData: "" }));
		if (!editando) {
			setValues((current) => ({ ...current, notificarACadaKm: 0 }));
			setValues((current) => ({ ...current, notificarAutomatico: false }));
		}
		setValidator((current) => ({ ...current, nome: "false" }));
		setValidator((current) => ({ ...current, ano: "false" }));
		setValidator((current) => ({ ...current, mes: "false" }));
		setValidator((current) => ({ ...current, dia: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando && profile?.token) {
			buscarTipoCheckagemPorId();
		}
	}, [editando]);

	useEffect(() => {
		if (props.idAtual) {
			buscarTipoCheckagemPorIdModal(props.idAtual);
		}
	}, [props.idAtual]);

	useEffect(() => {
		if (props.telaCadastro === true) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	useEffect(() => {
		setValues((current) => ({
			...current,
			notificarACadaData: `${valuesData.ano}a ${valuesData.mes}m ${valuesData.dia}d`,
		}));
	}, [valuesData]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Gerenciamento de Frota Configurações"));
			buscarTipoCheckagem();
		}
	}, [profile?.token]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="TipoCheckagemContainer">
						<div className="content-container">
							<Separator size="xl" />
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="idTipoCheck"
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.TipoCheckagem}
								dados={dadosTabela}
								isLoading={loading}
							/>
						</div>
						<div className="footer-space-between">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="TipoCheckagemCadastroContainer">
						<div className="content-container">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">
											{"Dados de Tipo de Checkagem /"}
										</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Checkagem"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Checkagem"}</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setValues({});
													setValuesData({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div className="container-select-emb">
									<div className="rota-div-2">
										<div className="coluna-emb">
											<div>
												<p className="input-label-emb" htmlFor="descricao">
													Nome:
												</p>
												<input
													type="text"
													className="input-emb"
													style={{ width: "250px" }}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													placeholder="Ex: Troca de Óleo"
													value={values.nome}
													disabled={props.desabilitar}
												/>
											</div>
										</div>
									</div>
									{values.notificarAutomatico === true && (
										<div className="rota-div-2">
											<div className="coluna-emb">
												<div>
													<p className="input-label-emb" htmlFor="descricao">
														Tipo Notificação:
													</p>
													<Select
														className="input-emb"
														variant="standard"
														id="tipoNotificacao"
														placeholder="Selecione"
														style={{ width: 250 }}
														value={values.tipoNotificacao}
														disabled={props.desabilitar}
													>
														{tipoNotificacao.map((data) => (
															<MenuItem
																key={data}
																value={data}
																onClick={(e) => {
																	if (data === "Por KM") {
																		setValues((current) => ({
																			...current,
																			tipoNotificacao: "Por KM",
																		}));
																		setValidator((current) => ({
																			...current,
																			tipoNotificacao: "true",
																		}));
																		setValidator((current) => ({
																			...current,
																			ano: "true",
																		}));
																		setValidator((current) => ({
																			...current,
																			dia: "true",
																		}));
																		setValidator((current) => ({
																			...current,
																			mes: "true",
																		}));
																	} else {
																		setValues((current) => ({
																			...current,
																			tipoNotificacao: "Por Data",
																		}));
																		setValidator((current) => ({
																			...current,
																			tipoNotificacao: "true",
																		}));
																		setValidator((current) => ({
																			...current,
																			ano: "true",
																		}));
																		setValidator((current) => ({
																			...current,
																			dia: "true",
																		}));
																		setValidator((current) => ({
																			...current,
																			mes: "true",
																		}));
																	}
																}}
															>
																{data}
															</MenuItem>
														))}
													</Select>
												</div>
											</div>
										</div>
									)}
									{values.tipoNotificacao === "Por KM" && (
										<div className="rota-div-2">
											<div className="coluna-emb">
												<div>
													<p className="input-label-emb" htmlFor="descricao">
														KM:
													</p>
													<input
														type="number"
														className="input-emb"
														style={{ width: "250px" }}
														onChange={(e) => {
															setValues((current) => ({
																...current,
																notificarACadaKm: e.target.value,
															}));
															setValidator((current) => ({
																...current,
																notificarACadaKm: "true",
															}));
														}}
														placeholder="Ex: 100000"
														value={values.notificarACadaKm}
														disabled={props.desabilitar}
													/>
												</div>
											</div>
										</div>
									)}
									{values.tipoNotificacao === "Por Data" && (
										<>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Ano:
														</p>
														<Select
															className="input-emb"
															variant="standard"
															id="ano"
															placeholder="Selecione"
															style={{ width: 250 }}
															value={valuesData.ano}
															disabled={props.desabilitar}
															onChange={(e) => {
																setValuesData((current) => ({
																	...current,
																	ano: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	ano: "true",
																}));
															}}
														>
															{[...Array(11)].map((e, i) => (
																<MenuItem key={i} value={i}>
																	{i}
																	{i === valuesData.ano && (
																		<ClearIcon
																			className="info-icon"
																			onClick={(e) => {
																				setValuesData((current) => ({
																					...current,
																					ano: "",
																				}));
																				setValidator((current) => ({
																					...current,
																					ano: "false",
																				}));
																			}}
																		/>
																	)}
																</MenuItem>
															))}
														</Select>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Mês:
														</p>
														<Select
															className="input-emb"
															variant="standard"
															id="mes"
															placeholder="Selecione"
															style={{ width: 250 }}
															value={valuesData.mes}
															disabled={props.desabilitar}
															onChange={(e) => {
																setValuesData((current) => ({
																	...current,
																	mes: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	mes: "true",
																}));
															}}
														>
															{[...Array(13)].map((e, i) => (
																<MenuItem key={i} value={i}>
																	{i}
																	{i === valuesData.mes && (
																		<ClearIcon
																			className="info-icon"
																			onClick={(e) => {
																				setValuesData((current) => ({
																					...current,
																					mes: "",
																				}));
																				setValidator((current) => ({
																					...current,
																					mes: "false",
																				}));
																			}}
																		/>
																	)}
																</MenuItem>
															))}
														</Select>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div>
														<p className="input-label-emb" htmlFor="descricao">
															Dia:
														</p>
														<Select
															className="input-emb"
															variant="standard"
															id="dia"
															placeholder="Selecione"
															style={{ width: 250 }}
															value={valuesData.dia}
															disabled={props.desabilitar}
															onChange={(e) => {
																setValuesData((current) => ({
																	...current,
																	dia: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	dia: "true",
																}));
															}}
														>
															{[...Array(32)].map((e, i) => (
																<MenuItem key={i} value={i}>
																	{i}
																	{i === valuesData.dia && (
																		<ClearIcon
																			className="info-icon"
																			onClick={(e) => {
																				setValuesData((current) => ({
																					...current,
																					dia: "",
																				}));
																				setValidator((current) => ({
																					...current,
																					dia: "false",
																				}));
																			}}
																		/>
																	)}
																</MenuItem>
															))}
														</Select>
													</div>
												</div>
											</div>
										</>
									)}
								</div>
								<div className="rota-div-2">
									<div className="coluna-emb">
										<div>
											<input
												type="checkbox"
												checked={values.notificarAutomatico}
												onChange={(e) => {
													setValues((current) => ({
														...current,
														notificarAutomatico: e.target.checked,
													}));
												}}
												disabled={props.desabilitar}
											></input>
											Notificar Automático
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
										setTelaCadastro(false);
										setEditando(false);
										setValues({});
										setValuesData({});
									}}
								/>
							) : (
								<>
									{!props.desabilitar ? (
										props.botaoCadastrar ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.nome !== "" &&
														validator.nome === "true" &&
														valuesData.dia !== "" &&
														validator.dia === "true" &&
														valuesData.mes !== "" &&
														validator.mes === "true" &&
														valuesData.ano !== "" &&
														validator.ano === "true"
													) {
														cadastrar();
														setValues({});
														setValuesData({});
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										) : (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													if (
														values.nome !== "" &&
														validator.nome === "true" &&
														valuesData.dia !== "" &&
														validator.dia === "true" &&
														valuesData.mes !== "" &&
														validator.mes === "true" &&
														valuesData.ano !== "" &&
														validator.ano === "true"
													) {
														cadastrar();
														setValuesData({});
														setValues({});
														setTelaCadastro(false);
													} else {
														setTextoErro("Há campos sem preencher!");
														setOpenToastErro(true);
													}
												}}
											/>
										)
									) : (
										<></>
									)}
								</>
							)}
							{props.botaoVoltar ? (
								<></>
							) : (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setValuesData({});
										setTelaCadastro(false);
										setEditando(false);
										setTabelaRedux({});
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<div>
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarTipoCheckagemPorId}
				/>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
			</div>
			<div>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</Layout>
	);
}

export default TipoCheckagem;
